import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage.tsx';
import {rbacActions} from '../../config/rbac/actions.ts';

// FNP-861: READ-ONLY module — only an index and a detail route. There is
// deliberately no add or edit route.
export const TestObservationsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListTestObservations}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetTestObservation}>
                        <DetailPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
